module.exports = "/fonts/opensanslight.woff";